/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
import * as i0 from "./first-steps-numbers.component.scss.shim.ngstyle";
import * as i1 from "@angular/core";
import * as i2 from "./first-steps-numbers.component";
import * as i3 from "@angular/router";
import * as i4 from "../../shared/services/amplitude.service";
var styles_FirstStepsNumbersComponent = [i0.styles];
var RenderType_FirstStepsNumbersComponent = i1.ɵcrt({ encapsulation: 0, styles: styles_FirstStepsNumbersComponent, data: {} });
export { RenderType_FirstStepsNumbersComponent as RenderType_FirstStepsNumbersComponent };
export function View_FirstStepsNumbersComponent_0(_l) { return i1.ɵvid(0, [], null, null); }
export function View_FirstStepsNumbersComponent_Host_0(_l) { return i1.ɵvid(0, [(_l()(), i1.ɵeld(0, 0, null, null, 1, "cc-first-steps-numbers", [], null, null, null, View_FirstStepsNumbersComponent_0, RenderType_FirstStepsNumbersComponent)), i1.ɵdid(1, 114688, null, 0, i2.FirstStepsNumbersComponent, [i3.Router, i4.AmplitudeService], null, null)], function (_ck, _v) { _ck(_v, 1, 0); }, null); }
var FirstStepsNumbersComponentNgFactory = i1.ɵccf("cc-first-steps-numbers", i2.FirstStepsNumbersComponent, View_FirstStepsNumbersComponent_Host_0, {}, {}, []);
export { FirstStepsNumbersComponentNgFactory as FirstStepsNumbersComponentNgFactory };
